// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2jtnJ","row":"Node_row__114ia","label":"Node_label__TdBGS","footer":"Node_footer__2wPqv"};